import React from "react";
import { Modal, Button,Row,Col,Container } from 'react-bootstrap';
import ReactDOM from "react-dom";
import { ExclamationCircle } from 'react-bootstrap-icons';

class ModalFunction extends React.Component {

  state = {
    showModal: false,
  }

    // handleClose = () => {console.log("Se seteara en false showModal"); this.setState({ showModal: false })};

  render() {
     const { titulo, texto, opcion, mostrarModal,infoFooter } = this.props;
    const modal = document.querySelector("#modalGrid");
    if (infoFooter) {var info ="hola"} else {var info ="";}
    return ReactDOM.createPortal(<>
      <Modal  size="lg" show={mostrarModal} onHide={this.props.parentCallBack}>
        <Modal.Header closeButton>
          <Modal.Title>{titulo}</Modal.Title>
        </Modal.Header>
        <Modal.Body size="lg" className="show-grid">
        <Container>
        <div class='alert alert-primary' role='alert'>
        {texto.map((element)=>{
          return  <Row>
            
            <Col xs={6} md={6}>
            • <b>{element.atributo}:</b> 
            </Col>
            <Col xs={6} md={6}>
            {element.valor}
            </Col>
          </Row>
        })}
        </div>
        {infoFooter ? <div class='alert alert-warning' role='alert'> <ExclamationCircle size={20} />{infoFooter}</div> : ''}
        
        
        
        </Container>
        </Modal.Body>
        
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.parentCallBack}>
            Cerrar
            </Button>
          <Button variant="primary" onClick={this.props.parentCallbackCondition} style={{display: this.props.displayOpcion}}>
            {opcion}
          </Button>
        </Modal.Footer>
      
      </Modal>
    </>, modal);
  }



}

export default ModalFunction;